import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { Col, Form, FormGroup, Input, Label, ModalFooter, Row } from 'reactstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CustomUploadAdapterPlugin } from '../../utils/MyUploadAdapter';
import { Btn } from '../../AbstractElements';
import { addQuestion } from '../../store/questionSlice';
import CustomizerContext from '../../_helper/Customizer';


const AddQuestionsTable = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [mainId, setmainId] = useState('')
    const [questionType, setQuestionType] = useState('')
    const [submit, setSubmit] = useState(false);
    const { layoutURL } = useContext(CustomizerContext);
    const storeVar = useSelector(state => state.question)


    const [formVar, setFormVar] = useState({
        questionEnglish: '',
        questionBengali: '',
        answer1English: '',
        answer1Bengali: '',
        answer2English: '',
        answer2Bengali: '',
        answer3English: '',
        answer3Bengali: '',
        answer4English: '',
        answer4Bengali: '',
        answer5English: '',
        answer5Bengali: '',
        correctAnswer: '1',
        answerJustificationEnglish: '',
        answerJustificationBengali: '',
        youtubeExplanationEnglish: '',
        youtubeExplanationBengali: '',
    });



    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const id = searchParams.get("id");
        const type = searchParams.get("type");
        setmainId(id);
        if (type) {
            setQuestionType(type);
        }
    }, [location.search]);

    // Question
    const onChangeQuestionEnglish = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, questionEnglish: evt }))
    };
    const onFocusQuestionEnglish = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, questionEnglish: evt }))
    }
    const onChangeQuestionBengali = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, questionBengali: evt }))
    };
    const onFocusQuestionBengali = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, questionBengali: evt }))
    }
    //Answer1
    const onChangeAnswer1English = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer1English: evt }))
    };
    const onFocusAnswer1English = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer1English: evt }))
    }
    const onChangeAnswer1Bengali = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer1Bengali: evt }))
    };
    const onFocusAnswer1Bengali = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer1Bengali: evt }))
    }
    //Answer2
    const onChangeAnswer2English = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer2English: evt }))
    };
    const onFocusAnswer2English = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer2English: evt }))
    }
    const onChangeAnswer2Bengali = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer2Bengali: evt }))
    };
    const onFocusAnswer2Bengali = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer2Bengali: evt }))
    }
    //Answer3
    const onChangeAnswer3English = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer3English: evt }))
    };
    const onFocusAnswer3English = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer3English: evt }))
    }
    const onChangeAnswer3Bengali = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer3Bengali: evt }))
    };
    const onFocusAnswer3Bengali = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer3Bengali: evt }))
    }
    //Answer 4
    const onChangeAnswer4English = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer4English: evt }))
    };
    const onFocusAnswer4English = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer4English: evt }))
    }
    const onChangeAnswer4Bengali = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer4Bengali: evt }))
    };
    const onFocusAnswer4Bengali = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer4Bengali: evt }))
    }
    // Answer 5 (Optional)
    const onChangeAnswer5English = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer5English: evt }))
    };
    const onFocusAnswer5English = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer5English: evt }))
    }
    const onChangeAnswer5Bengali = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer5Bengali: evt }))
    };
    const onFocusAnswer5Bengali = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answer5Bengali: evt }))
    }
    // Answer Justification
    const onChangeAnswerJustificationEnglish = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answerJustificationEnglish: evt }))
    };
    const onFocusAnswerJustificationEnglish = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answerJustificationEnglish: evt }))
    }
    const onChangeAnswerJustificationBengali = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answerJustificationBengali: evt }))
    };
    const onFocusAnswerJustificationBengali = (editor) => {
        const evt = editor.getData()
        setFormVar((prevFormVar) => ({ ...prevFormVar, answerJustificationBengali: evt }))
    }


    const handleInputChange = (e) => {
        setFormVar((prevFormVar) => ({ ...prevFormVar, correctAnswer: e.target.value }))
    };
    const submitMenu = () => {

        // if (questionEnglishValid() || questionBengaliValid() || answer1EnglishValid() || answer1BengaliValid() ||
        //     answer2EnglishValid() || answer2BengaliValid() || answer3EnglishValid() || answer3BengaliValid() || answer4EnglishValid() ||
        //     answer4BengaliValid() || correctValid() || answerJustificationEnglishValid() || answerJustificationBengaliValid()) {
        //     setSubmit(true)
        //     return null
        // }
        // setSubmit(false)
        const data = {
            lessonId: mainId,
            questionEnglish: formVar.questionEnglish,
            answer1English: formVar.answer1English,
            answer2English: formVar.answer2English,
            answer3English: formVar.answer3English,
            answer4English: formVar.answer4English,
            answer5English: formVar.answer5English,
            questionBengali: formVar.questionBengali,
            answer1Bengali: formVar.answer1Bengali,
            answer2Bengali: formVar.answer2Bengali,
            answer3Bengali: formVar.answer3Bengali,
            answer4Bengali: formVar.answer4Bengali,
            answer5Bengali: formVar.answer5Bengali,
            correctAnswer: formVar.correctAnswer,
            answerJustificationEnglish: formVar.answerJustificationEnglish,
            answerJustificationBengali: formVar.answerJustificationBengali,
            youtubeExplanationEnglish: formVar.youtubeExplanationEnglish,
            youtubeExplanationBengali: formVar.youtubeExplanationBengali,
        }
        dispatch(addQuestion(data))
    }

    const questionEnglishValid = () => {
        if (!formVar.questionEnglish) {
            return "Question in English is required";
        }
    }
    const questionBengaliValid = () => {
        if (!formVar.questionBengali) {
            return "Question in Bengali is required";
        }
    }
    const answer1EnglishValid = () => {
        if (!formVar.answer1English) {
            return "Answer 1 in English is required";
        }
    }
    const answer1BengaliValid = () => {
        if (!formVar.answer1Bengali) {
            return "Answer 1 in Bengali is required";
        }
    }
    const answer2EnglishValid = () => {
        if (!formVar.answer2English) {
            return "Answer 2 in English is required";
        }
    }
    const answer2BengaliValid = () => {
        if (!formVar.answer2Bengali) {
            return "Answer 2 in Bengali is required";
        }
    }
    const answer3EnglishValid = () => {
        if (!formVar.answer3English) {
            return "Answer 3 in English is required";
        }
    }
    const answer3BengaliValid = () => {
        if (!formVar.answer3Bengali) {
            return "Answer 3 in Bengali is required";
        }
    }
    const answer4EnglishValid = () => {
        if (!formVar.answer4English) {
            return "Answer 4 in English is required";
        }
    }
    const answer4BengaliValid = () => {
        if (!formVar.answer4Bengali) {
            return "Answer 4 in Bengali is required";
        }
    }

    const correctValid = () => {
        if (!formVar.correctAnswer) {
            return "Correct answer is Required";
        }
    }
    const answerJustificationEnglishValid = () => {
        if (!formVar.answerJustificationEnglish) {
            return "Answer Explanation in English is Required";
        }
    }
    const answerJustificationBengaliValid = () => {
        if (!formVar.answerJustificationBengali) {
            return "Answer Explanation in Bengali is Required";
        }
    }

    const handlePreview = () => {
        window.open("/preview-test/" + layoutURL + "?id=" + storeVar.addPreviewId, "_blank");
    }
    return (
        <>

            <Form>
                <FormGroup>
                    <Label className="col-form-label" for="recipient-name">Question in English</Label>
                    <CKEditor
                        editor={ClassicEditor}
                        data={formVar.questionEnglish || ''}
                        onReady={editor => {
                            onFocusQuestionEnglish(editor)
                        }}
                        onFocus={(event, editor) => {
                            onFocusQuestionEnglish(editor)
                        }}
                        onChange={(event, editor) => {
                            onChangeQuestionEnglish(editor);
                        }}
                        onBlur={(event, editor) => {
                        }}
                        config={{
                            extraPlugins: [CustomUploadAdapterPlugin],
                        }}
                    />
                    {submit && questionEnglishValid() ? <span className='d-block font-danger'>{questionEnglishValid()}</span> : ""}
                    <Label className="col-form-label" for="recipient-name">Question in Bengali</Label>
                    <CKEditor
                        editor={ClassicEditor}
                        data={formVar.questionBengali || ''}
                        onReady={editor => {
                            onFocusQuestionBengali(editor)
                        }}
                        onFocus={(event, editor) => {
                            onFocusQuestionBengali(editor)
                        }}
                        onChange={(event, editor) => {
                            onChangeQuestionBengali(editor);
                        }}
                        onBlur={(event, editor) => {
                        }}
                        config={{
                            extraPlugins: [CustomUploadAdapterPlugin],
                        }}
                    />
                    {submit && questionBengaliValid() ? <span className='d-block font-danger'>{questionBengaliValid()}</span> : ""}
                    <Row>
                        <Col md={6}>
                            <Label className="col-form-label" for="recipient-name">Answer 1 in English</Label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={formVar.answer1English || ''}
                                onReady={editor => {
                                    onFocusAnswer1English(editor)
                                }}
                                onChange={(event, editor) => {
                                    onChangeAnswer1English(editor);
                                }}
                                onBlur={(event, editor) => {
                                }}
                                onFocus={(event, editor) => {
                                    onFocusAnswer1English(editor)
                                }}
                                config={{
                                    extraPlugins: [CustomUploadAdapterPlugin],
                                }}
                            />
                            {submit && answer1EnglishValid() ? <span className='d-block font-danger'>{answer1EnglishValid()}</span> : ""}
                        </Col>
                        <Col md={6}>
                            <Label className="col-form-label" for="recipient-name">Answer 1 in Bengali</Label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={formVar.answer1Bengali || ''}
                                onReady={editor => {
                                    onFocusAnswer1Bengali(editor)
                                }}
                                onChange={(event, editor) => {
                                    onChangeAnswer1Bengali(editor);
                                }}
                                onBlur={(event, editor) => {
                                }}
                                onFocus={(event, editor) => {
                                    onFocusAnswer1Bengali(editor)
                                }}
                                config={{
                                    extraPlugins: [CustomUploadAdapterPlugin],
                                }}
                            />
                            {submit && answer1BengaliValid() ? <span className='d-block font-danger'>{answer1BengaliValid()}</span> : ""}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Label className="col-form-label" for="recipient-name">Answer 2 in English</Label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={formVar.answer2English || ''}
                                onReady={editor => {
                                    onFocusAnswer2English(editor)
                                }}
                                onChange={(event, editor) => {
                                    onChangeAnswer2English(editor);
                                }}
                                onBlur={(event, editor) => {
                                }}
                                onFocus={(event, editor) => {
                                    onFocusAnswer2English(editor)
                                }}
                                config={{
                                    extraPlugins: [CustomUploadAdapterPlugin],
                                }}
                            />
                            {submit && answer2EnglishValid() ? <span className='d-block font-danger'>{answer2EnglishValid()}</span> : ""}
                        </Col>
                        <Col md={6}>
                            <Label className="col-form-label" for="recipient-name">Answer 2 in Bengali</Label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={formVar.answer2Bengali || ''}
                                onReady={editor => {
                                    onFocusAnswer2Bengali(editor)
                                }}
                                onChange={(event, editor) => {
                                    onChangeAnswer2Bengali(editor);
                                }}
                                onBlur={(event, editor) => {
                                }}
                                onFocus={(event, editor) => {
                                    onFocusAnswer2Bengali(editor)
                                }}
                                config={{
                                    extraPlugins: [CustomUploadAdapterPlugin],
                                }}
                            />
                            {submit && answer2BengaliValid() ? <span className='d-block font-danger'>{answer2BengaliValid()}</span> : ""}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Label className="col-form-label" for="recipient-name">Answer 3 in English</Label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={formVar.answer3English || ''}
                                onReady={editor => {
                                    onFocusAnswer3English(editor)
                                }}
                                onChange={(event, editor) => {
                                    onChangeAnswer3English(editor);
                                }}
                                onBlur={(event, editor) => {
                                }}
                                onFocus={(event, editor) => {
                                    onFocusAnswer3English(editor)
                                }}
                                config={{
                                    extraPlugins: [CustomUploadAdapterPlugin],
                                }}
                            />
                            {submit && answer3EnglishValid() ? <span className='d-block font-danger'>{answer3EnglishValid()}</span> : ""}
                        </Col>
                        <Col md={6}>
                            <Label className="col-form-label" for="recipient-name">Answer 3 in Bengali</Label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={formVar.answer3Bengali || ''}
                                onReady={editor => {
                                    onFocusAnswer3Bengali(editor)
                                }}
                                onChange={(event, editor) => {
                                    onChangeAnswer3Bengali(editor);
                                }}
                                onBlur={(event, editor) => {
                                }}
                                onFocus={(event, editor) => {
                                    onFocusAnswer3Bengali(editor)
                                }}
                                config={{
                                    extraPlugins: [CustomUploadAdapterPlugin],
                                }}
                            />
                            {submit && answer3BengaliValid() ? <span className='d-block font-danger'>{answer3BengaliValid()}</span> : ""}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Label className="col-form-label" for="recipient-name">Answer 4 in English</Label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={formVar.answer4English || ''}
                                onReady={editor => {
                                    onFocusAnswer4English(editor)
                                }}
                                onChange={(event, editor) => {
                                    onChangeAnswer4English(editor);
                                }}
                                onBlur={(event, editor) => {
                                }}
                                onFocus={(event, editor) => {
                                    onFocusAnswer4English(editor)
                                }}
                                config={{
                                    extraPlugins: [CustomUploadAdapterPlugin],
                                }}
                            />
                            {submit && answer4EnglishValid() ? <span className='d-block font-danger'>{answer4EnglishValid()}</span> : ""}
                        </Col>
                        <Col md={6}>
                            <Label className="col-form-label" for="recipient-name">Answer 4 in Bengali</Label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={formVar.answer4Bengali || ''}
                                onReady={editor => {
                                    onFocusAnswer4Bengali(editor)
                                }}
                                onChange={(event, editor) => {
                                    onChangeAnswer4Bengali(editor);
                                }}
                                onBlur={(event, editor) => {
                                }}
                                onFocus={(event, editor) => {
                                    onFocusAnswer4Bengali(editor)
                                }}
                                config={{
                                    extraPlugins: [CustomUploadAdapterPlugin],
                                }}
                            />
                            {submit && answer4BengaliValid() ? <span className='d-block font-danger'>{answer4BengaliValid()}</span> : ""}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Label className="col-form-label" for="recipient-name">Answer 5 in English <span className="text-muted">(Optional)</span></Label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={formVar.answer5English || ''}
                                onReady={editor => {
                                    onFocusAnswer5English(editor)
                                }}
                                onChange={(event, editor) => {
                                    onChangeAnswer5English(editor);
                                }}
                                onBlur={(event, editor) => {
                                }}
                                onFocus={(event, editor) => {
                                    onFocusAnswer5English(editor)
                                }}
                                config={{
                                    extraPlugins: [CustomUploadAdapterPlugin],
                                }}
                            />
                        </Col>
                        <Col md={6}>
                            <Label className="col-form-label" for="recipient-name">Answer 5 in Bengali <span className="text-muted">(Optional)</span></Label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={formVar.answer5Bengali || ''}
                                onReady={editor => {
                                    onFocusAnswer5Bengali(editor)
                                }}
                                onChange={(event, editor) => {
                                    onChangeAnswer5Bengali(editor);
                                }}
                                onBlur={(event, editor) => {
                                }}
                                onFocus={(event, editor) => {
                                    onFocusAnswer5Bengali(editor)
                                }}
                                config={{
                                    extraPlugins: [CustomUploadAdapterPlugin],
                                }}
                            />
                        </Col>
                    </Row>
                    <Label className="col-form-label" for="recipient-name">Correct Answer</Label>
                    <Col md="4">
                        <Input className="form-control form-control-inverse btn-square" name="select" type="select"
                            value={formVar.correctAnswer} onChange={handleInputChange}>
                            <option value='1'>1</option>
                            <option value='2'>2</option>
                            <option value='3'>3</option>
                            <option value='4'>4</option>
                            <option value='5'>5</option>
                        </Input>
                    </Col>
                    {submit && correctValid() ? <span className='d-block font-danger'>{correctValid()}</span> : ""}
                    <Label className="col-form-label" for="recipient-name">Answer Explanation in English</Label>
                    <CKEditor
                        editor={ClassicEditor}
                        data={formVar.answerJustificationEnglish || ''}
                        onReady={editor => {
                            onFocusAnswerJustificationEnglish(editor)
                        }}
                        onFocus={(event, editor) => {
                            onFocusAnswerJustificationEnglish(editor)
                        }}
                        onChange={(event, editor) => {
                            onChangeAnswerJustificationEnglish(editor);
                        }}
                        onBlur={(event, editor) => {
                        }}
                        config={{
                            extraPlugins: [CustomUploadAdapterPlugin],
                        }}
                    />
                    {submit && answerJustificationEnglishValid() ? <span className='d-block font-danger'>{answerJustificationEnglishValid()}</span> : ""}

                    {(questionType === 'mockTest' || questionType === 'mocktest') && (
                        <>
                            <Label className="col-form-label" for="youtube-explanation-english">YouTube Explanation Link (English)</Label>
                            <Input
                                id="youtube-explanation-english"
                                className="form-control mb-2"
                                type="text"
                                placeholder="Enter YouTube explanation link for English (e.g. https://www.youtube.com/watch?v=...)"
                                value={formVar.youtubeExplanationEnglish}
                                onChange={(e) => setFormVar((prev) => ({ ...prev, youtubeExplanationEnglish: e.target.value }))}
                            />
                        </>
                    )}

                    <Label className="col-form-label" for="recipient-name">Answer Explanation in Bengali</Label>
                    <CKEditor
                        editor={ClassicEditor}
                        data={formVar.answerJustificationBengali || ''}
                        onReady={editor => {
                            onFocusAnswerJustificationBengali(editor)
                        }}
                        onFocus={(event, editor) => {
                            onFocusAnswerJustificationBengali(editor)
                        }}
                        onChange={(event, editor) => {
                            onChangeAnswerJustificationBengali(editor);
                        }}
                        onBlur={(event, editor) => {
                        }}
                        config={{
                            extraPlugins: [CustomUploadAdapterPlugin],
                        }}
                    />
                    {submit && answerJustificationBengaliValid() ? <span className='d-block font-danger'>{answerJustificationBengaliValid()}</span> : ""}

                    {(questionType === 'mockTest' || questionType === 'mocktest') && (
                        <>
                            <Label className="col-form-label" for="youtube-explanation-bengali">YouTube Explanation Link (Bengali)</Label>
                            <Input
                                id="youtube-explanation-bengali"
                                className="form-control mb-2"
                                type="text"
                                placeholder="Enter YouTube explanation link for Bengali (e.g. https://www.youtube.com/watch?v=...)"
                                value={formVar.youtubeExplanationBengali}
                                onChange={(e) => setFormVar((prev) => ({ ...prev, youtubeExplanationBengali: e.target.value }))}
                            />
                        </>
                    )}
                </FormGroup>
            </Form>
            <ModalFooter style={{ marginBlock: '50px', display: 'flex', gap: '10px' }}>
                <Btn attrBtn={{ color: 'secondary', onClick: () => navigate(-1) }} >Back</Btn>
                <Btn attrBtn={{ color: 'primary', onClick: submitMenu }}>Save Changes</Btn>
            </ModalFooter>
        </>
    )
}

export default AddQuestionsTable